/**
 * `?` — the prefix list (PLAN §2.1 mode 6), generated from the registry, so it
 * lists exactly the registered (and available) prefixes. Enter inserts the
 * chosen prefix as a chip.
 */
import { CircleHelp } from 'lucide-react';
import { ORDER } from './order';
import { getProviders } from '../registry';
import { selectTop } from '../localSearch';

export function prefixLabel(p) {
  if (p.prefixes && p.prefixes.length) return `${p.prefixes[0]}:`;
  return (p.sigils || [])[0] || '';
}

export function helpResults(ctx, providers = getProviders()) {
  const out = [];
  for (const p of providers) {
    if (p.id === 'help') continue;
    if (!(p.prefixes || []).length && !(p.sigils || []).length) continue;
    let ok = false;
    try {
      ok = p.available(ctx);
    } catch {
      ok = false;
    }
    if (!ok) continue;
    const aliases = [...(p.prefixes || []).slice(1).map((w) => `${w}:`), ...(p.sigils || [])];
    out.push({
      provider: 'help',
      id: p.id,
      title: ctx.t(p.labelKey),
      subtitle: aliases.join('  ') || undefined,
      keyLabel: prefixLabel(p),
      icon: p.icon,
      payload: { providerId: p.id },
    });
  }
  return out;
}

export default function create() {
  return {
    id: 'help',
    prefixes: ['help'],
    sigils: ['?'],
    labelKey: 'palette.scope.help',
    icon: CircleHelp,
    order: ORDER.help,
    kind: 'local-sync',
    inGlobal: false,
    available: () => true,
    search(req) {
      return selectTop(helpResults(req.ctx), { ...req, limit: 200 });
    },
    actions() {
      return [
        {
          id: 'insertPrefix',
          titleKey: 'palette.action.insertPrefix',
          icon: CircleHelp,
          keepOpen: true,
          run: (r, ctx) => ctx.palette?.setScope?.(r.payload.providerId),
        },
      ];
    },
  };
}
